export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-06.ba3e0127.jpg";